import React, { Component } from "react";

import terms from "../../assets/documents/dpo.pdf";

class Dpo extends Component {
  render() {
    return (
      <div style={{ height: "100vh", overflowY: "hidden" }}>
        <iframe src={terms} height="100%" width="100%" />
      </div>
    );
  }
}

export default Dpo;
